import { type FC } from "react";

import { CancelledIcon, HideIcon, OfflineIcon, ShowIcon } from "@snapchat/snap-design-system-icons";

import { VisibilityOption } from "./VisibilityOption";
import {
    VisibilityDoNotPublishToSnapchat,
    VisibilityDoNotPublishToSnapchatDescription,
    VisibilityHidden,
    VisibilityHiddenDescription,
    VisibilityOffline,
    VisibilityOfflineDescription,
    VisibilityPublic,
    VisibilityPublicDescription,
} from "./messages.generated";
import { type VisibilityOptionProps } from "./shared.types";

export const VisibilityPublicOption: FC<VisibilityOptionProps> = ({
    setVisibility,
    loading,
    selected,
    disabledVisibilityOptionConfig,
    className,
}) => (
    <VisibilityOption
        label={<VisibilityPublic />}
        description={<VisibilityPublicDescription />}
        Icon={ShowIcon}
        setVisibility={setVisibility}
        loading={loading}
        selected={selected}
        disabledVisibilityOptionConfig={disabledVisibilityOptionConfig}
        className={className}
    />
);

export const VisibilityHiddenOption: FC<VisibilityOptionProps> = ({
    setVisibility,
    loading,
    selected,
    disabledVisibilityOptionConfig,
    className,
}) => (
    <VisibilityOption
        label={<VisibilityHidden />}
        description={<VisibilityHiddenDescription />}
        Icon={HideIcon}
        setVisibility={setVisibility}
        loading={loading}
        selected={selected}
        disabledVisibilityOptionConfig={disabledVisibilityOptionConfig}
        className={className}
    />
);

export const VisibilityOfflineOption: FC<VisibilityOptionProps> = ({
    setVisibility,
    loading,
    selected,
    disabledVisibilityOptionConfig,
    className,
}) => (
    <VisibilityOption
        label={<VisibilityOffline />}
        description={<VisibilityOfflineDescription />}
        Icon={OfflineIcon}
        setVisibility={setVisibility}
        loading={loading}
        selected={selected}
        disabledVisibilityOptionConfig={disabledVisibilityOptionConfig}
        className={className}
    />
);

export const VisibilityDontPublishToSnapchatOption: FC<VisibilityOptionProps> = ({
    setVisibility,
    loading,
    selected,
    disabledVisibilityOptionConfig,
    className,
}) => (
    <VisibilityOption
        label={<VisibilityDoNotPublishToSnapchat />}
        description={<VisibilityDoNotPublishToSnapchatDescription />}
        Icon={CancelledIcon}
        setVisibility={setVisibility}
        loading={loading}
        selected={selected}
        disabledVisibilityOptionConfig={disabledVisibilityOptionConfig}
        className={className}
    />
);
